import {IAdvertiserLogins} from "../interfaces/IAdvertiserLogins";

export const initialAdvertiserLoginObj: IAdvertiserLogins = {
    organizationId: '',
    advertiserLoginId: '',
    publisherName: '',
    advertiserName: '',
    demandPartners: []
}
